module.exports = __webpack_public_path__ + "static/media/whatsapp.43bf2881.svg";